import { render, staticRenderFns } from "./HomesForSale.vue?vue&type=template&id=1f6c0a35&scoped=true&"
import script from "./HomesForSale.vue?vue&type=script&lang=ts&"
export * from "./HomesForSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c0a35",
  null
  
)

export default component.exports